import Vuex from 'vuex';
import Vue from 'vue';
import overlay from './modules/overlay';
import auth from './modules/auth'
import reports from './modules/reports'
import comments from './modules/comments'
import menu from './modules/menu'
import configuration from './modules/configuration'
 
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        overlay: overlay,
        auth: auth,
        reports: reports,
        comments: comments,
        menu: menu,
        configuration,
    }
})